(function (jQuery, Drupal) {

  'use strict';
  var once = true;
  Drupal.behaviors.contact = {
    attach: function (context, settings) {
      if (once) {
        once = false;

        var $page = jQuery('body.page-node-type-page-contact');
        if ($page.length > 0) {
          var $form = $page.find('article.node--type-page-contact.node--view-mode-full .field--name-field-contact form');

          var $who = $form.find('.form-item-field-who select');
          var $object = $form.find('.field--name-field-object select');
          var $objectFree = $form.find('.field--name-field-object-free input');
          var $companyName = $form.find('.field--name-field-company-name');
          var $siret = $form.find('.field--name-field-siret');

          $who.on('change', function (event) {
            var value = $who.val();
            $object.show();
            $object.find('option').show();
            $companyName.show();
            $siret.show();
            switch (value) {
              case 'particulier':
                $object.find('option[value="adv"]').hide();
                $companyName.hide();
                $siret.hide();
                break;
              case 'distributeur':
                $object.find('option[value="recherche_installateur"]').hide();
                break;
              case 'installateur':
                $object.find('option[value="adv"]').hide();
                $object.find('option[value="recherche_installateur"]').hide();
                break;
              case 'architecte':
                $object.find('option[value="adv"]').hide();
                break;
              case 'autre':
                $object.find('option[value="adv"]').hide();
                break;
              case 'presse':
                $object.val('autre_choix');
                $object.trigger('change');
                $object.hide();
                break;
              case 'fournisseur':
                $object.val('autre_choix');
                $object.trigger('change');
                $object.hide();
                break;
            }
          });

          $object.on('change', function (event) {
            var value = $object.val();
            switch (value) {
              case 'autre_choix':
                $objectFree.show();
                break;
              default:
                $objectFree.val('');
                $objectFree.hide();
                break;
            }
          });
        }
      }
    }
  };

})(jQuery, Drupal);